import React, { useState } from "react";
import OrderCardDiff from "./OrderCardDiff";

// import JS files

const COrderCard = ({ children, ring, item, adminNeedDifference }) => {
  return (
    <>
      <div className="grid md:grid-cols-5">
        <div className="md:col-span-1 text-sm  mb-4 md:mb-0">
          <div>
            <span className="text-myblue-100">{ring.code}</span>/
            <span className="text-myblue-100">{ring.show_name}</span>/
            <span className="text-myblue-100">{ring.brand_name}</span>/
            <span className="bg-slate-100 rounded-lg py-1 px-2">
              {ring.gender == "girl" ? "بچه گانه" : "زنانه"}
            </span>
            /
            {ring.color == "yellow" ? (
              <span className="bg-yellow-400 rounded-lg py-1 px-2">زرد</span>
            ) : (
              <span className="bg-slate-50 border border-slate-200 rounded-lg py-1 px-2">
                سفید
              </span>
            )}
          </div>
          {adminNeedDifference && (
            <div className="mt-2">
              <OrderCardDiff
                item={item}
                adminNeedDifference={adminNeedDifference}
              />
            </div>
          )}
        </div>

        <div className="md:col-span-4">{children}</div>
      </div>
    </>
  );
};

export default COrderCard;
